import React from "react";
import "./sections.scss";

function TriadSec({item,link}){


    return(
        <div key={item.items && item.items[0]?.uid} className="triad-container">
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <div className="triad-row">
                {item.items?.map(it=>{
                    return(
                        <div className={`triad-item ${item.has_shadow?"shadow-sec":""}`}  onClick={e=>link(it.link_to,it)}>
                            <img src={it.image} alt=""/>
                            <span>{it.title}</span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default TriadSec
